module.exports = __webpack_public_path__ + "static/media/vanessa.711c721e.jpg";